import { h } from 'preact';
import PageWrapper from '../PageWrapper';
import {
  SuccessIcon,
  ClockIcon,
  CloseIcon,
  GearIcon,
  FaceIcon,
  CarIcon,
  FailIcon,
  DangerIcon,
  CarCancelIcon,
  CarNextIcon,
} from '../Icons';
import Button from '../Button';
import { AssistButtonAction, AssistContent, AssistRenderType } from '../../types';
import { useEffect, useMemo, useState } from 'preact/hooks';
import { memo } from 'preact/compat';
import './styles.scss';
import { useTimer } from '../../hooks';

// const arRegExp = /[\u0600-\u06ff,\u0750-\u077f,\ufb50-\ufbc1\ufbd3-\ufd3f\ufd50-\ufd8f\ufd92-\ufdc7\ufe70-\ufefc\uFDF0-\uFDFD]+/gi

interface Props {
  onHideModal: () => void;
  onNextStep: ({ action, renderType }: { action: AssistButtonAction; renderType: AssistRenderType }) => void;
  content: AssistContent;
  renderType: AssistRenderType;
}

const iconByName = name => {
  switch (name) {
    case 'car':
      return CarIcon;
    case 'dsp_next':
      return CarNextIcon;
    case 'clock':
      return ClockIcon;
    case 'face':
      return FaceIcon;
    case 'false':
      return FailIcon;
    case 'gear':
      return GearIcon;
    case 'true':
      return SuccessIcon;
    case 'warning':
      return DangerIcon;
    case 'dsp_cancel':
      return CarCancelIcon;
    default:
      return DangerIcon;
  }
};

function IconStepTitle({ title, className }: { title: string; className: string }) {
  const [timerHasStarted, setTimerHasStarted] = useState(false);

  const { minutes, seconds, restart } = useTimer({
    expiryTimestamp: undefined,
    onExpire: () => {
      // onClick('button')
    },
  });

  useEffect(() => {
    const [_, time] = title.match(/\*timer\*(\d+)\*timer\*/) ?? [];

    if (!timerHasStarted && +time > 0) {
      setTimerHasStarted(true);
      restart(+time * 1000 + Date.now());
    } else if (timerHasStarted && time === undefined) {
      restart(Date.now());
      setTimerHasStarted(false);
    }
  }, [title, restart, timerHasStarted]);

  return (
    <h2 className={className}>
      {title.replace(/\*timer\*\d+\*timer\*/, seconds > 0 && minutes === 0 ? '1' : String(minutes))}
    </h2>
  );
}

function IconStep({ content, onHideModal, onNextStep, renderType }: Props) {
  const IconComponent = useMemo(() => iconByName(content.icon), [content.icon]);

  return (
    <PageWrapper>
      <div className="modal-header_ta headless_ta">
        <div style={{ flex: 1 }} />
        <CloseIcon className="close-button_ta" size={14} onClick={onHideModal} />
      </div>
      <div className="modal-body_ta centered_ta">
        <IconComponent />
        <IconStepTitle title={content.title} className="icon-step__title" />
        {content.subtitle && <h2 className="icon-step__subtitle secondary-page-subtitle">{content.subtitle}</h2>}
        <div className="buttons-wrapper_ta">
          {content.buttons.map((button, i) => (
            <Button
              key={i}
              data={button}
              className={'icon-step__button'}
              onClick={() => onNextStep({ action: button.action, renderType })}
            />
          ))}
        </div>
      </div>
    </PageWrapper>
  );
}

export default memo(IconStep);
